import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { OpTextButton } from 'new-components/DLS/OpTextButton/OpTextButton';

import './ClearAllAlertsButton.scss';

interface ClearAllAlertsButtonProps {
  onClick: () => void;
  bottomOffset?: number;
  ariaLabel?: string;
}

export const ClearAllAlertsButton = ({
  onClick,
  bottomOffset,
  ariaLabel,
}: ClearAllAlertsButtonProps) => {
  const { t } = useTranslation();
  const hasOffset = bottomOffset != null;

  return (
    <div
      className={clsx('clear-all-alerts-button')}
      style={hasOffset ? { bottom: bottomOffset } : undefined}
    >
      <OpTextButton
        className="clear-all-alerts-button__text-button"
        size="small"
        onClick={onClick}
        aria-label={ariaLabel}
        style={hasOffset ? { bottom: bottomOffset + 4 } : undefined}
      >
        {t('Clear all')}
      </OpTextButton>
    </div>
  );
};
